<template>
  <div id="app">
    <div id="page-container">
      <div id="header-container">
        <div id="logo-title-container">
          <div id="logo-container">
            <a :href="mwnf_website">
              <img src="./assets/logo.jpg" alt="MWNF Logo" />
            </a>
          </div>
          <div id="explore-logo-container">
            <router-link :to="{ name: 'home' }">
              <img src="./assets/explorelogo_wide.png" alt="Explore Logo" />
            </router-link>
          </div>
        </div>
        <div id="links-search-container">
          <div id="header-links" v-if="!lessThan949">
            <router-link :to="{ name: 'whats-new' }">What's New?</router-link>
            <router-link :to="{ name: 'about' }">About</router-link>
            <router-link :to="{ name: 'credits' }">Credits</router-link>
            <router-link :to="{ name: 'get-involved' }"
              >Get Involved</router-link
            >
          </div>
          <div id="search-container">
            <div id="search-button">
              <button class="search-button" @click="showSearchOverlay = true">
                <font-awesome-icon :icon="['fas', 'search']" id="search-icon" />
              </button>
            </div>
            <transition name="fade" mode="out-in">
              <div id="search-overlay" v-if="showSearchOverlay">
                <button
                  id="search-overlay-close"
                  v-if="showSearchOverlay === true"
                  @click="showSearchOverlay = false"
                >
                  <font-awesome-icon :icon="['fas', 'times']" />
                </button>
                <div class="search-types-container">
                  <button class="search-type" :class="{ 'search-selected': searchMWNF }"
                    @click="searchHandler('mwnf')">
                    MWNF Database Search
                  </button>
                  <button class="search-type" :class="{ 'search-selected': searchGoogle }"
                    @click="searchHandler('google')">
                    Google-powered Search
                  </button>
                </div>
                <form id="search" @submit.prevent>
                  <!-- <input
                    id="search-input"
                    type="search"
                    v-model="input"
                    :placeholder="`Enter ${searchPlaceholder} search term(s) here`"
                  /> -->
                  <input
                    id="search-input"
                    type="search"
                    v-model="input"
                    :placeholder="`Results will be based on ${searchPlaceholder} Search`"
                  />
                  <button
                    class="search-button"
                    type="submit"
                    @click="search($event)"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'search']"
                      id="search-icon"
                    />
                  </button>
                </form>
                <router-link :to="{ name: 'important-information' }">
                  Important Information
                </router-link>
              </div>
            </transition>
          </div>
          <!-- Mobile menu view -->
          <div id="header-hamburger-container" v-if="lessThan949">
            <button
              class="header-hamburger-button"
              @click="showHeaderHamburgerOverlay = true"
            >
              <font-awesome-icon :icon="['fas', 'bars']" id="hamburger-icon" />
            </button>
          </div>
          <div
            id="header-hamburger-overlay"
            v-if="lessThan949 && showHeaderHamburgerOverlay"
          >
            <button
              id="header-hamburger-overlay-close"
              v-if="showHeaderHamburgerOverlay === true"
              @click="showHeaderHamburgerOverlay = false"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </button>
            <div id="header-hamburger-links">
              <router-link :to="{ name: 'whats-new' }">What's New?</router-link>
              <router-link :to="{ name: 'about' }">About</router-link>
              <a href="#explore-by-theme" v-if="home">Explore by Theme</a>
              <router-link
                :to="{ name: 'home', hash: '#explore-by-theme' }"
                v-else
              >
                Explore by Theme
              </router-link>
              <a href="#explore-by-country" v-if="home">Explore by Country</a>
              <router-link
                :to="{ name: 'home', hash: '#explore-by-country' }"
                v-else
              >
                Explore by Country
              </router-link>
              <a href="#explore-by-itinerary" v-if="home"
                >Explore by Itinerary</a
              >
              <router-link
                :to="{ name: 'home', hash: '#explore-by-itinerary' }"
                v-else
              >
                Explore by Itinerary
              </router-link>
              <router-link :to="{ name: 'credits' }">Credits</router-link>
              <router-link :to="{ name: 'get-involved' }"
                >Get Involved</router-link
              >
            </div>
          </div>
        </div>
      </div>

      <BannerComponent></BannerComponent>
      <NavigationMenu></NavigationMenu>

      <!-- Set up "views" for components -->
      <!-- Empty view is where main components for other pages is inserted -->
      <!-- Refer to route.js -->
      <router-view></router-view>

      <div id="footer-container">
        <div id="non-social-media-container">
          <div id="footer-links">
            <a :href="mwnf_website" target="_blank">MWNF Home</a>
            <router-link :to="{ name: 'home' }">Home</router-link>
            <a :href="mwnf_website + '/about'" target="_blank"
              >About</a
            >
            <router-link :to="{ name: 'get-involved' }"
              >Get involved</router-link
            >
            <a :href="mwnf_website + '/about/contact'" target="_blank"
              >Contact</a
            >
            <a :href="mwnf_website + '/about/legal-notice'" target="_blank"
              >Important Legal Notice</a
            >
            <a :href="mwnf_website + '/about/credits'" target="_blank"
              >Credits</a
            >
            <a :href="mwnf_website + '/about/cookies'" target="_blank"
              >Cookies</a
            >
          </div>
          <div id="language-policy">
            Language policy: Most descriptions are available in English, some in
            the country language only. Other languages are available for
            specific themes or countries, please refer to the language menu.
          </div>
          <div id="copyright">
            <font-awesome-icon :icon="['far', 'copyright']" />
            Museum With No Frontiers (MWNF), 2004—{{ currentYear }}
          </div>
        </div>
        <div id="social-media-container">
          <div id="follow-us" v-if="!lessThan499">Follow us</div>
          <div id="social-media-links">
            <a
              href="https://www.youtube.com/channel/UC5X2a5jDFyIfTEV5prWNF5Q"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'youtube-square']" />
            </a>
            <a href="https://twitter.com/mwnf_org/" target="_blank">
              <font-awesome-icon :icon="['fab', 'square-x-twitter']" />
            </a>
            <a
              href="http://www.facebook.com/pages/Museum-With-No-Frontiers/370544525423"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'facebook-square']" />
            </a>
            <a
              href="https://www.instagram.com/museumwithnofrontiers/"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
            <a
              href="https://www.weibo.com/6540990409/profile?topnav=1&wvr=6&is_all=1"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'weibo']" />
            </a>
            <a
              href="https://www.linkedin.com/company/museum-with-no-frontiers/"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'linkedin']" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import media from "./mixins/media.js";
import BannerComponent from "./components/BannerComponent.vue";
import NavigationMenu from "./components/NavigationMenu.vue";
export default {
  name: "App",
  components: {
    BannerComponent: BannerComponent,
    NavigationMenu: NavigationMenu,
  },
  mixins: [media],
  data() {
    return {
      input: "",
      showHeaderHamburgerOverlay: false,
      showSearchOverlay: false,
      lessThan499: window.matchMedia("(max-width: 499px)").matches,
      lessThan949: window.matchMedia("(max-width: 949px)").matches,
      home: true,
      searchGoogle: false,
      searchMWNF: true,
      searchPlaceholder: "MWNF Database",
      searchType: "mwnf",
      mwnf_website: process.env.VUE_APP_MWNF_WEBSITE,
      api_website: process.env.VUE_APP_API_ENDPOINT,
    };
  },
  watch: {
    $route(to, from) {
      this.setHome(this.$route.name);
      this.showHeaderHamburgerOverlay = false;
      this.showSearchOverlay = false;
      // Set Google search if on search page and Google has been selected
      if (this.$route.name === "search" && this.$route.params.type === "google") {
        this.$global.lastSearchType = "google";
        this.searchHandler('google');
      }
    },
    lessThan949() {
      if (!this.lessThan949) {
        this.showHeaderHamburgerOverlay = false;
      }
    },
    showSearchOverlay() {
      if (!this.showSearchOverlay) {
        this.input = "";
      }
    }
  },
  methods: {
    searchHandler: function (type) {
      if (type === 'google') {
        this.searchType = "google";
        this.searchGoogle = true;
        this.searchMWNF = false;
        this.searchPlaceholder = "Google Custom";
      } else if (type === 'mwnf') {
        this.searchType = "mwnf";
        this.searchGoogle = false;
        this.searchMWNF = true;
        this.searchPlaceholder = "MWNF Database";
      }
      console.log(this.searchType, this.$global.lastSearchType);
    },
    search: function (e) {
      if (this.input === "") {
        alert("Please enter a search term!");
        return;
      }
      if (this.$global.lastSearchType === this.searchType && this.input === this.$route.query.q) {
        alert("The results for this search term are already being displayed!");
        return;
      }
      this.showSearchOverlay = false;
      e.preventDefault();
      this.$router.push({ name: "search", params: { type: this.searchType }, query: { q: this.input } });
    },
    setHome: function (name) {
      if (name === "home") {
        this.home = true;
      } else {
        this.home = false;
      }
    },
  },
  mounted() {
    // Set Google search if on search page and Google has been selected
    if (this.$route.name === "search" && this.$route.params.type === "google") {
      this.$global.lastSearchType = "google";
      this.searchHandler('google');
    // Default to MWNF search
    } else {
      this.$global.lastSearchType = "mwnf";
      this.searchHandler('mwnf');
    }
  },
  created() {
    this.setHome(this.$route.name);
    this.currentYear = new Date().getFullYear();
  },
};
</script>

<style lang="scss">
/* See borders while designing pages */
// * {
//   border: 1px dashed red;
// }

* {
  @include header-font;
  margin: 0;
  padding: 0;
  font-size: 100%;
}
*,
::before,
::after {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  cursor: pointer;
}
a:hover {
  text-decoration: underline;
}

body {
  @include flex-center;
  align-items: flex-start;
  background-color: $background-color;
}

#page-container {
  @include flex-center;
  flex-direction: column;
  justify-content: flex-start;
  width: 1350px;
  max-width: 1350px;
  background-color: $white;
  box-shadow: 0 2px 8px 2px $light-grey;
}

#header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  color: $dark-blue;
  background-color: $white;
  // border-bottom: 1px solid $dark-blue;
  box-shadow: 0 2px 8px $light-grey;
  padding: 15px 40px;
}
#header-container a {
  color: $dark-blue;
}
#logo-title-container {
  @include flex-center;
}
#logo-container {
  margin-right: 20px;
}
#logo-container img {
  height: 50px;
  width: 125px;
}
#explore-logo-container {
  @include flex-center;
}
#explore-logo-container img {
  height: 50px;
  width: auto;
}
#links-search-container {
  @include flex-center;
}
#header-links {
  @include headings;
  @include font-size-4;
  text-transform: none;
  font-weight: normal;
  margin-right: 40px;
}
#header-links a {
  margin-right: 30px;
}
#header-links a:last-child {
  margin-right: 0;
}
#search-overlay {
  @include flex-center;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  height: 335px;
  width: 100%;
  background-color: rgba($dark-green, 0.7);
  z-index: 5;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#search-overlay-close {
  @include button-styles;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 200%;
  color: white;
  padding: 10px 20px;
}
#search-overlay-close:focus {
  outline: none;
}
.search-types-container {
  @include flex-center;
  justify-content: space-evenly;
  width: 60%;
  position: relative;
}
  .search-type {
    @include button-styles;
    position: relative;
    height: 50px;
    width: 50%;
    font-weight: bold;
    color: white;
    background-color: $dark-green;
    border: 2px solid white;
    border-bottom: 0;
    border-radius: 10px 10px 0 0;
    margin: 0 5px;
  }
  .search-type::before {
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(black, 0.3);
    border: 2px solid rgba(black, 0.3);
    border-radius: 10px 10px 0 0;
  }
    // .search-selected {
    //   color: $light-green;
    //   // background-color: white;
    // }
    .search-type.search-selected::before {
      background-color: transparent;
      border: none;
    }
#search {
  @include flex-center;
  width: 100%;
  position: relative;
}
#search-input {
  @include font-size-6;
  height: 50px;
  width: 75%;
  border: 1px solid $medium-green;
  border-radius: 5px;
  box-shadow: inset 0px 1px 4px rgba(0, 0, 0, 0.25);
  padding: 6px 10px;
  margin-right: 5px;
}
#search-input::placeholder {
  @include headings;
  @include font-size-5;
  font-weight: normal;
  color: $medium-grey;
}
#search-input:focus {
  color: $dark-blue;
}
.search-button {
  @include button-styles;
  height: 50px;
  width: 50px;
  background-color: white;
  color: $dark-green;
  border-radius: 5px;
}
#search-button .search-button {
  height: 35px;
  width: 35px;
  color: white;
  background-color: $dark-blue;
}
#search-overlay a {
  color: white;
  margin: 10px;
}

#footer-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: $white;
  background-color: $dark-blue;
  padding: 60px;
  margin-top: 100px;
}
#footer-container a {
  color: $white;
}
#non-social-media-container {
  margin-right: 200px;
}
#footer-links {
  @include font-size-6;
  display: flex;
  flex-wrap: wrap;
}
#footer-links a {
  @include body-font;
  margin-top: 10px;
  margin-right: 30px;
}
#footer-links a:last-child {
  margin-right: 0;
}
#language-policy {
  @include body-font;
  @include font-size-7;
  margin: 30px 0 20px 0;
}
#copyright {
  @include body-font;
  @include font-size-7;
}
#social-media-container {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
#follow-us {
  @include body-font;
  @include font-size-6;
  margin-bottom: 10px;
}
#social-media-links {
  font-size: 30px;
  display: grid;
  grid-template-columns: repeat(6, 32px);
  grid-gap: 10px;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #social-media-links {
    display: flex;
  }
  #social-media-links a {
    margin-right: 10px;
  }
}

#cookie-notice-container {
  @include flex-center;
  @include font-size-6;
  height: 52px;
  width: 100%;
  position: fixed;
  bottom: 0;
  color: white;
  background-color: $dark-blue;
}
#cookie-notice-container a {
  color: $white;
  text-decoration: underline;
}
#cookie-notice-button button {
  @include button-styles;
  @include font-size-7;
  color: $white;
  border: 1px solid $white;
  border-radius: 5px;
  padding: 5px 12px;
  margin-left: 20px;
}

@media only screen and (max-width: 1349px) {
  #page-container {
    width: 100vw;
  }
}

@media only screen and (max-width: 1199px) {
  #header-links {
    @include font-size-5;
  }
  #search-overlay {
    height: 435px;
  }
  #search-overlay-close {
    font-size: 175%;
    padding: 10px 20px;
  }
  #search-input::placeholder {
    @include font-size-6;
  }
  #footer-container {
    flex-direction: column-reverse;
  }
  #non-social-media-container {
    margin-right: 0;
  }
  #social-media-container {
    flex-direction: row;
    align-items: center;
    margin-right: 0;
    margin-bottom: 20px;
  }
  #follow-us {
    margin-right: 20px;
    margin-bottom: 0;
  }
}

@media only screen and (max-width: 949px) {
  #search-overlay {
    height: 285px;
  }
  .search-types-container {
    width: 75%;
  }
  .header-hamburger-button {
    @include button-styles;
    height: 35px;
    width: 35px;
    color: white;
    background-color: $dark-blue;
    border-radius: 5px;
    margin-left: 10px;
  }
  #header-hamburger-overlay {
    @include flex-center;
    position: absolute;
    top: 0;
    left: 0;
    height: 285px;
    width: 100%;
    background-color: rgba($dark-green, 0.9);
    z-index: 5;
  }
  #header-hamburger-overlay-close {
    @include button-styles;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 200%;
    color: white;
    padding: 10px 20px;
  }
  #header-hamburger-overlay-close:focus {
    outline: none;
  }
  #header-hamburger-links {
    @include headings;
    @include font-size-4;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    justify-content: space-evenly;
    align-items: center;
    height: 100%;
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    #header-hamburger-links {
      padding: 20px;
    }
  }
  #header-hamburger-links a {
    color: white;
  }
  #footer-container {
    padding: 40px;
  }
}

@media only screen and (max-width: 499px) {
  #header-container {
    padding: 15px 25px;
  }
  #header-hamburger-overlay {
    height: 270px;
  }
  #search-overlay {
    height: 270px;
  }
  #search-overlay-close {
    font-size: 150%;
    padding: 10px 20px;
  }
  #logo-container {
    margin-right: 10px;
  }
  #logo-container img,
  #explore-logo-container img {
    height: 35px;
    width: auto;
  }
  #header-hamburger-overlay-close {
    font-size: 150%;
  }
  #header-hamburger-links {
    @include font-size-5;
  }
  #footer-links,
  #follow-us {
    @include font-size-7;
  }
  #social-media-links {
    font-size: 22px;
  }
}

@media only screen and (max-width: 374px) {
  #header-container {
    padding: 15px 15px;
  }
  #header-hamburger-overlay {
    height: 268px;
  }
  #search-overlay {
    height: 268px;
  }
  #logo-container img,
  #explore-logo-container img {
    height: 32px;
    width: auto;
  }
}
</style>
